import { ExcludePick } from '../abstract/exclude-pick';
import { Module } from '../abstract/module.class';
import { ModuleType } from '../abstract/module.type';
import { Font } from '../object';
import { Text } from '../object/text/text.class';
import { WinningList } from '../object/winning-list/winning-list.class';
import { $, WritableSignal } from '../signal';
import { ScoreSection1Question } from './section-1-question/score-section-1-question.class';
import { ScoreSection2Answer } from './section-2-answer/score-section-2-answer.class';
import { ScoreSection3Winner } from './section-3-winner/score-section-3-winner.class';

export type ScoreQuestion = {
  title: string;
  options: ScoreOption[];
};

export type ScoreOption = {
  text: string;
  isAnswer: WritableSignal<boolean>;
};

export class ScoreModule extends Module {
  public static override moduleName = '積分模組';

  public name = '積分模組';

  public override showInCreateDialog = true;

  public override isBeta = true;

  public override readonly type = ModuleType.SCORE;

  public override filmstrips: (
    | ScoreSection1Question
    | ScoreSection2Answer
    | ScoreSection3Winner
  )[] = [
    new ScoreSection1Question(),
    new ScoreSection2Answer(),
    new ScoreSection3Winner(),
  ];

  public override data = {
    answerRankingColor: $.signal('#9C5F37FF'),
    questions: $.signal<ScoreQuestion[]>([
      {
        title: '題目 1',
        options: [
          { text: '選項 A', isAnswer: $.signal(true) },
          { text: '選項 B', isAnswer: $.signal(false) },
          { text: '選項 C', isAnswer: $.signal(false) },
        ],
      },
    ]),

    answerRankingName: new Font({ align: 'left' }),
    answerRankingScore: new Font({ align: 'left' }),
    winningList: new WinningList(),
    wrongText1: new Text({ content: '答錯了～正確答案是', align: 'center' }),
    wrongText2: new Text({ content: '請等待下一個環節', align: 'center' }),
    wrongFont: new Font({ align: 'center' }),
  } as const;

  public override dataError = $.computed(() => ({
    winningList: this.data.winningList.error(),
    wrongText1: this.data.wrongText1.error(),
    wrongText2: this.data.wrongText2.error(),
    wrongFont: this.data.wrongFont.error(),
  }));

  public constructor(module: Partial<ScoreModule> = {}) {
    super();
    this.fromJSON(module);
  }

  public override fromJSON(json: any) {
    if (json.data) {
      this.updateFilmstripCount(
        json.data.questions.value
          ? json.data.questions.value.length
          : json.data.questions.length,
      );
    }
    super.fromJSON(json);
  }

  public updateFilmstripCount(count: number) {
    this.filmstrips = [];
    for (let i = 0; i < count; i++) {
      this.filmstrips.push(
        new ScoreSection1Question(),
        new ScoreSection2Answer(),
      );
    }

    this.filmstrips[this.filmstrips.length - 1].nextButtonName = '公布結果';

    this.filmstrips.push(new ScoreSection3Winner());

    for (let i = 0; i < this.filmstrips.length; i++) {
      this.filmstrips[i].module = this;
    }
  }
}

export type CountMarioData = ExcludePick<ScoreModule, Module>;
